import apiCall from 'auth/ApiCallInstance'

const AuthService = {}

AuthService.login = function (data) {
	return apiCall({
		url: '/auth/login',
		method: 'post',
		data: data,
		skipAuth: true,
	})
}

AuthService.register = function (data) {
	return apiCall({
		url: '/auth/register',
		method: 'post',
		data: data,
		skipAuth: true,
	})
}

AuthService.getCurrentUser = function () {
	return apiCall({
		url: '/auth/me',
		method: 'get',
	})
}

AuthService.logout = function (refreshToken) {
	return apiCall({
		url: '/auth/logout',
		method: 'post',
		data: { refreshToken },
	})
}

AuthService.logoutAll = function () {
	return apiCall({
		url: '/auth/logout-all',
		method: 'post',
	})
}

AuthService.changePassword = function (data) {
	return apiCall({
		url: '/auth/change-password',
		method: 'put',
		data: data,
	})
}

AuthService.setPassword = function (data) {
	return apiCall({
		url: '/auth/set-password',
		method: 'put',
		data: data,
	})
}

export default AuthService;
